import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const utilsMCountriesApi = createApi({
  reducerPath: 'utilsMCountriesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Countries'],
  endpoints: builder => ({
    
    getCountries: builder.query({
      query: (params) => ({
        url:'/utils/countries/',
        params,
      }),
      providesTags: ['Countries'],
    }),

   
    getCountryByCode: builder.query({
      query: code => `/utils/countries/${code}/`,
      providesTags: ['Countries'],
    }),
  }),
});

export const {
  useGetCountriesQuery,
  useGetCountryByCodeQuery,
} = utilsMCountriesApi;
